import assetCategoryService from "../../../../services/assetService/assetCategoryService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_ASSETCATEGORIES } from "../../../../utils/constants";
import { AssetCategoryInterface } from "../../../../models/AssetModel/AssetCategory";

interface AddAssCategoriesContext {
  previousAssCategories: AssetCategoryInterface[];
}

const useAddAssCategories = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    AssetCategoryInterface,
    Error,
    AssetCategoryInterface,
    AddAssCategoriesContext
  >({
    mutationFn: assetCategoryService.Save,

    onMutate: () => {
      const previousAssCategories =
        queryClient.getQueryData<AssetCategoryInterface[]>([
          CACHE_KEY_ASSETCATEGORIES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      return { previousAssCategories };
    },

    onSuccess: (savedAssLocation) => {
      queryClient.setQueryData<AssetCategoryInterface[]>(
        [
          CACHE_KEY_ASSETCATEGORIES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        (assLocations) =>
          assLocations
            ? [savedAssLocation, ...assLocations]
            : [savedAssLocation]
      );
    },

    onError: (error, newAssCategory, context) => {
      if (!context) return;

      queryClient.setQueryData<AssetCategoryInterface[]>(
        [
          CACHE_KEY_ASSETCATEGORIES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousAssCategories
      );
    },
  });
};

export default useAddAssCategories;
